module.exports = "<svg viewBox=\"0 0 300 240\"><path d=\"M0 0v117.6h111.5l-25.1-25 13.5-13.4 47.9 47.9L99.9 175l-13.5-13.4 25.1-25H0V240h300V0H0z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/img-arrow.svg
// module id = 294
// module chunks = 1